import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppService} from '../app.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {UserPassword} from '../app.model';
import {CommonDialogComponent} from '../common-dialog/common-dialog.component';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
  params: any;
  id: number;
  code: string;
  userSetPassword: UserPassword = new UserPassword();
  disableSetPassword = false;
  showSetPasswordForm = undefined;
  confirmPassword = '';
  showPassword: boolean;
  confirmPasswordfield: boolean;
  baseWord: string = this.appService.getBaseWord();
  uncommonBaseWord: string = this.appService.getUncommonBaseWord();

  constructor(private route: ActivatedRoute, private appService: AppService,
              private dialog: MatDialog, private router: Router) {
    this.route.queryParams.subscribe(params => {
      this.params = params;
    });
  }

  ngOnInit() {
    if (this.params.id && this.params.code) {
      this.id = this.params.id;
      this.code = this.params.code;
      this.verifyEmail();
    } else {
      this.router.navigate(['/']);
    }
  }

  verifyEmail() {
    this.appService.verifyEmail(this.id, this.code).then((message) => {
      if (message.status === 260) {
        // forgot password verification
        this.showSetPasswordForm = true;
      } else {
        // normal signup verification
         this.router.navigate(['/']);
        this.appService.saveDataToFirebaseDatabase(this.id);
        const dialogRef = this.dialog.open(CommonDialogComponent, {
          data: {
            title: 'Account activated',
            content: 'Your account has been activated. You can login now.',
            image: 'successful',
            buttons : [
              {
                'title': 'OK',
                'meta': '/' + this.uncommonBaseWord + '/login',
                'type' : 'redirect',
                'class' : 'confirm-dialog-later'
              }
            ]
          },
          disableClose: true
        });


        dialogRef.afterClosed().subscribe(result => {
          if (result?.type === 'redirect') {
            this.router.navigate(['/' + this.baseWord + '/datasources-listing']);
          }
        });
      }
    });
  }
toggleShowPassword() {
this.showPassword = !this.showPassword;
}
toggleConfirmPassword() {
this.confirmPasswordfield = !this.confirmPasswordfield;
}

  setForgotPasswordFormSubmit() {
    this.disableSetPassword = true;
    this.userSetPassword.userId = this.id;
    this.appService.setPassword(this.userSetPassword, this.code).then((message) => {
      /*const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: 'Reset Password Successful ',
          //content: 'You will be redirected to login',
          image: '../../assets/images/tickmark.jpg',
          buttons : [
            {
              'title': 'OK',
              'meta': '/'+ this.uncommonBaseWord + '/login',
              'type' : 'redirect',
              'class' : 'confirm-dialog-later'
            }
          ]
        },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.type === 'redirect') {
          this.router.navigate(['/' + this.baseWord + '/datasources-listing']);

        }
      });*/
      this.showSetPasswordForm = false;
    });
  }

}
